<template>
    <app-modal
        v-if="showModal"
        modal-id="export-all-modal"
        modal-size="default"
        @close-modal="closeModal"
    >
        <div class="modal-body">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('export_type')"
                        v-model="exportType"
                        :options="exportTypeOptions"
                        list-value-field="value"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('department')"
                        type="select"
                        v-model="selectedDepartment"
                        :options="departments"
                        list-value-field="name"
                        :required="true"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('start_date')"
                        v-model="startDate"
                        :placeholder="$t('enter_start_date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('end_date')"
                        v-model="endDate"
                        :placeholder="$t('enter_end_date')"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group-selectable
                        :label="$t('users')"
                        type="multi-select"
                        v-model="selectedUsers"
                        :options="departmentUsers"
                        list-value-field="employee_name"
                        :placeholder="$t('select_employee')"
                    />
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary ml-2" @click="confirmExport" :disabled="!selectedDepartment || isInvalidDateRange">
                {{ $t('export') }}
            </button>
        </div>
    </app-modal>
</template>

<script>
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {getDateRange, serverDateFormat, startAndEndOf} from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name: "ExportAllAttendanceModal",
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        timeRange: {
            type: [Object, String],
            default: () => ({})
        },
        filterState: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            exportType: 'simple',
            exportTypeOptions: [
                {id: 'simple', value: this.$t('simple')},
                {id: 'advance', value: this.$t('advance')},
            ],
            selectedDepartment: null,
            selectedUsers: [],
            startDate: '',
            endDate: '',
            departments: [],
            departmentUsers: [],
        }
    },
    computed: {
        isInvalidDateRange() {
            if ((this.startDate && !this.endDate) || (!this.startDate && this.endDate)) {
                return true;
            }
            return this.startDate && this.endDate ? this.startDate > this.endDate : false;
        }
    },
    methods: {
        initializeDateRange() {
            let range = this.timeRange || {};
            if (typeof range === 'string') {
                try {
                    range = JSON.parse(range || '{}');
                } catch (e) {
                    range = {};
                }
            }

            if (range?.start && range?.end) {
                this.startDate = range.start;
                this.endDate = range.end;
                return;
            }

            const within = this.filterState?.within;
            if (within) {
                const selectedRange = getDateRange(within);
                if (Array.isArray(selectedRange)) {
                    this.startDate = selectedRange[0].format(serverDateFormat);
                    this.endDate = selectedRange[1].format(serverDateFormat);
                    return;
                }

                const singleDay = selectedRange.format(serverDateFormat);
                this.startDate = singleDay;
                this.endDate = singleDay;
                return;
            }

            const year = this.filterState?.year;
            const monthNumber = this.filterState?.month_number;
            if (year && (monthNumber || monthNumber === 0)) {
                const selectedRange = startAndEndOf(year, monthNumber);
                this.startDate = selectedRange[0].format(serverDateFormat);
                this.endDate = selectedRange[1].format(serverDateFormat);
                return;
            }

            this.startDate = '';
            this.endDate = '';
        },
        closeModal() {
            this.$emit('close-modal');
            $("#export-all-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.resetData();
        },
        confirmExport() {
            this.$emit('confirm-export', {
                exportType: this.exportType,
                selectedDepartment: this.selectedDepartment,
                selectedUsers: this.selectedUsers,
                startDate: this.startDate,
                endDate: this.endDate
            });
            this.closeModal();
        },
        resetData() {
            this.selectedDepartment = null;
            this.selectedUsers = [];
            this.startDate = '';
            this.endDate = '';
            this.departments = [];
            this.departmentUsers = [];
            this.exportType = 'simple';
        },
        loadDepartments() {
            axiosGet(this.apiUrl.SELECTABLE_HOLIDAY_DEPARTMENTS).then(response => {
                this.departments = response.data || [];
                this.selectedDepartment = this.departments?.[0].id;
            }).catch(() => {
                this.departments = [];
            });
        },
        loadDepartmentUsers() {
            this.selectedUsers = [];
            if (this.selectedDepartment) {
                axiosGet(`${this.apiUrl.SELECTABLE_WORK_SHIFT_USERS}?departments=${this.selectedDepartment}`).then(response => {
                    this.departmentUsers = response.data || [];
                }).catch(() => {
                    this.departmentUsers = [];
                });
            } else {
                this.departmentUsers = [];
            }
        }
    },
    watch: {
        showModal: {
            handler: function (newVal) {
                if (newVal) {
                    this.initializeDateRange();
                    this.loadDepartments();
                }
            },
            immediate: true
        },
        selectedDepartment: {
            handler: function (newVal) {
                if (newVal) {
                    this.loadDepartmentUsers();
                } else {
                    this.departmentUsers = [];
                    this.selectedUsers = [];
                }
            },
            immediate: false
        }
    },
}
</script>

<style scoped>
::v-deep .chips-container {
    min-height: 24vh !important;
}
</style>
